/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import pre from "../assets/img/pre.svg";
import next from "../assets/img/next.svg";
import { useEffect, useState } from "react";
import { annoHelper } from "../dal/annoHelper";
import { useNavigate } from 'react-router-dom';
import config from "../SysConfig.json";
import dayjs from "dayjs";
interface NewsProps {
  tag: string;
}


export const News = ({ tag }: NewsProps) => {
  const [allNews, setAllNews] = useState<any[]>([]);
  const [activePage, setActivePage] = useState(0);
  const [currPageGroup, setCurrPageGroup] = useState(0);
  const [annoCount, setAnnoCount] = useState(0);

  const navigate = useNavigate();

  const handleDecPageGroup = () => {
    if (currPageGroup !== 0) {
      setCurrPageGroup(currPageGroup - 1)
      setActivePage((currPageGroup - 1) * config.Pagination.page_group_size - 1)
    }

  }

  const handleIncPageGroup = () => {
    if (currPageGroup !== Math.floor(annoCount / config.Pagination.page_group_size)) {
      setCurrPageGroup(currPageGroup + 1)
      setActivePage((currPageGroup + 1) * config.Pagination.page_group_size - 1)
    }
  }

  const handleActivatePage = (pageNum: number) => {
    if ((pageNum - 1) < annoCount / config.Pagination.page_size)
      setActivePage(pageNum - 1)
  }


  const loadData = async () => {

    const annos = await annoHelper.getOpenConditionalAnnoWithFilters('', config.Pagination.page_size, activePage, tag, '');
    setAllNews(annos);
    const annosCount = await annoHelper.getOpenAnnoCountWithFilters('', tag, '');
    setAnnoCount(annos.count);
  }
  useEffect(() => {
    loadData();
  }, [activePage]);
  return (
    <>
      <div className='border-[3px] border-primary custom-shadow p-4 lg:px-10 lg:py-6'>
        <div className=''>
          {
            allNews.map((anno) => {
              return (
                <div className='flex justify-between items-center text-base lg:text-lg gap-y-1 gap-x-4 my-4 lg:my-6'>
                  <div className='flex items-center gap-5 lg:gap-10'>
                    {
                      (anno.is_top) ?
                        <div className='bt-yellow flex-shrink-0 w-20 lg:w-24 py-1'>{anno.unit_name}</div> :
                        <div className='bt-purple flex-shrink-0 w-20 lg:w-24 py-1'>{anno.unit_name}</div>
                    }
                    <a href={`/newsview?itemid=${anno.id}`} className='hover:underline clamp2'>{anno.title}</a>
                  </div>
                  <div className='shrink-0 text-[#9b9b9b] text-sm lg:text-xl ml-auto hidden lg:block'>{dayjs(anno.start_at).format('YYYY-MM-DD')}</div>
                </div>
              )
            })
          }

        </div>
        <div className='rounded-lg bt-green text-base lg:text-xl cursor-pointer hover:opacity-80 my-4 lg:my-8 mx-auto w-fit px-4 py-1'
          onClick={() => navigate('/newsall?init=true')}>查看更多</div>

        {/* <div className="text-center py-4">
            <nav className="inline-flex items-center gap-3 lg:gap-4" aria-label="Pagination">
              <a className="hover:opacity-70 focus-visible:outline-none cursor-pointer" onClick={() => handleDecPageGroup()}>
                <span><img src={pre} alt='' /></span>
              </a>
              {
                Array.from({ length: config.Pagination.page_group_size }).map
                  ((_, i) =>
                    (currPageGroup * config.Pagination.page_group_size + i + 1 === activePage + 1) ?
                      <a className="w-6 h-6 leading-6 hover:opacity-70 focus-visible:outline-none rounded-full text-white bg-primary cursor-pointer" onClick={() => handleActivatePage(currPageGroup * config.Pagination.page_group_size + i + 1)}>{activePage + 1}</a> :
                      <a className="w-6 h-6 leading-6 hover:opacity-70 focus-visible:outline-none text-primary cursor-pointer" onClick={() => handleActivatePage(currPageGroup * config.Pagination.page_group_size + i + 1)}>{currPageGroup * config.Pagination.page_group_size + i + 1}</a>
                  )
              }
              <a className="hover:opacity-70 focus-visible:outline-none cursor-pointer" onClick={() => handleIncPageGroup()}>
                <span><img src={next} alt='' /></span>
              </a>
            </nav>
          </div> */}
      </div>

    </>
  )

}